module.exports = __webpack_public_path__ + "static/summary1-8b214bab87cba76e2c6eaf7a9f37f927.png";